module.exports = __webpack_public_path__ + "img/eu-fund-flags.af0bdbe1.svg";